import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { InfoBubbleNotesWrapper } from "../components";
import ClientRetirementPlans from "../components/ClientRetirementPlans";
import FinalSalaryArrangements from "../components/FinalSalaryArrangements";
import PensionsArrangementsList from "../components/PensionsArrangementsList";
import useInvestments from "../hooks/useInvestments";

const InvestmentsWrapper = styled.div`
    > .row {
        margin-bottom: 16px;
    }
`;

const InvestmentsSection = () => {
    const {
        investmentsSection,
        isLoadingInvestmentsSection,
        isErrorInvestmentsSection,
        investmentsSectionError,
        hasFinalSalaryArrangements,
        hasPensionArrangements,
        updateNotes,
        refetchInvestments
    } = useInvestments();

    const { clientViewsOnEsg, sourceOfFunds, investmentPlanningObjectives, retirementPlanningObjectives, } = investmentsSection || {};

    if (isErrorInvestmentsSection) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={investmentsSectionError} retryCallback={refetchInvestments} />
        </ErrorMessageWrapper>;
    }

    if (isLoadingInvestmentsSection || !investmentsSection) return <Skeleton height={16} count={4} />;

    return <div className="container-fluid">
        <InvestmentsWrapper>
            <div className="row">
                <InfoBubbleNotesWrapper
                    label={"Investment Planning Objectives"}
                    fieldKey={"investmentPlanningObjectives"}
                    defaultValue={investmentPlanningObjectives.notes}
                    onBlur={(newValue) => updateNotes(investmentPlanningObjectives.notesId, newValue)}
                />
            </div>
            <div className="row">
                <InfoBubbleNotesWrapper
                    label={"Client's Views on ESG, Ethical or Other Investments"}
                    fieldKey={"viewsOnEsg"}
                    defaultValue={clientViewsOnEsg.notes}
                    onBlur={(newValue) => updateNotes(clientViewsOnEsg.notesId, newValue)}
                />
            </div>
            <div className="row">
                <InfoBubbleNotesWrapper
                    label={"Source of Funds"}
                    fieldKey={"sourceOfFunds"}
                    defaultValue={sourceOfFunds.notes}
                    onBlur={(newValue) => updateNotes(sourceOfFunds.notesId, newValue)}
                />
            </div>
            <div className="row">
                <ClientRetirementPlans />
            </div>
            <div className="row">
                <InfoBubbleNotesWrapper
                    label={"Retirement Planning Objectives"}
                    fieldKey={"retirementPlanningObjectives"}
                    defaultValue={retirementPlanningObjectives.notes}
                    onBlur={(newValue) => updateNotes(retirementPlanningObjectives.notesId, newValue)}
                />
            </div>
        </InvestmentsWrapper>
        <PensionsArrangementsList hasFinalSalaryArrangements={hasFinalSalaryArrangements} />
        <FinalSalaryArrangements hasPensionArrangements={hasPensionArrangements} />
    </div>;
};

export default InvestmentsSection;